import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

/**
 * Respuesta del tab Contenedores (detalle liquidación agencia) vía SP.
 * Columnas dinámicas: nombres exactos como retorna SQL Server (p. ej. [Total venta neto]).
 */
export class LiquidacionAgenciaContenedoresTabDto {
  @ApiProperty({
    description: 'Orden sugerido de columnas (cabecera de tabla)',
    type: [String],
    example: ['Nave', 'POL', 'ETD', 'NroContenedor', 'PLTS', 'Agenciamiento'],
  })
  columns!: string[];

  @ApiProperty({
    description: 'Filas de contenedores (objetos clave-valor por columna)',
    type: 'array',
    items: { type: 'object', additionalProperties: true },
  })
  rows!: Record<string, string | number | null>[];

  @ApiPropertyOptional({
    description:
      'Fila de totales (segundo recordset del SP); null si no aplica o vacío',
    type: 'object',
    additionalProperties: true,
  })
  totalsRow!: Record<string, string | number | null> | null;

  @ApiProperty({
    description: 'Cantidad de filas de contenedores (sin la fila de totales)',
    example: 12,
  })
  totalContenedores!: number;
}
